import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { TranslateService } from '@app/core/services/translate.service';

@Component({
    selector: 'tt-radio-button',
    templateUrl: './radio-button.component.html',
    styleUrls: ['./radio-button.component.css'],
})
export class RadioButtonComponent implements OnChanges {
    @Input()
    public ttLabel: string = '';

    /**
     * @default true
     */
    @Input()
    public set ttTranslateLabel(value: BooleanInput) {
        this._translateLabel = coerceBooleanProperty(value);
    }
    public get ttTranslateLabel(): boolean {
        return this._translateLabel;
    }
    private _translateLabel = true;

    /**
     * The label after translating or not transling.
     */
    public label = '';

    @Input()
    public ttDisabled = false;

    @Input()
    public ttValue = '';

    public name = '';

    public model = '';

    public modelChange = new EventEmitter<string>();

    @Output()
    public ttValueChange = new EventEmitter<string>();

    @ViewChild('inputRef')
    public inputRef?: ElementRef<HTMLInputElement>;

    constructor(private translate: TranslateService) {}

    private async setLabel(label: string) {
        if (this.ttTranslateLabel) {
            this.label = await this.translate.translate(label);
        } else {
            this.label = label;
        }
    }

    log(event: any) {
        console.dir(event);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['ttTranslateLabel']) {
            this.ttTranslateLabel = changes['ttTranslateLabel'].currentValue;
        }

        if (changes['ttLabel']) {
            this.setLabel(changes['ttLabel'].currentValue);
        }
    }
}
